
import Star from "../../../assets/duotone/Star.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StarIcon({ className, dataTestid = "StarIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Star data-testid={dataTestid} className={classes} {...rest} />
  );
}
